<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">User profile successfully updated.</div>
  }

  <div class='sheet'>
    <h1 class='header'>User Profile</h1>

    <app-tabs>
      <app-tab title='User Details'>
        <div class='form-row'>
          <div class="form-group col-md-4">
            <label for="inputEmail4">First Name</label>
            <input type="text" name='name' [(ngModel)]='this.user.firstName' [class.is-invalid]='!this.user.firstName' class="form-control" id="inputEmail4">
          </div>
          <div class="form-group col-md-4">
            <label for="inputPassword4">Middle Name</label>
            <input type="text" name='registration' [(ngModel)]='this.user.middleName' class="form-control" id="inputPassword4">
          </div>
          <div class="form-group col-md-4">
            <label for="inputPassword4">Last Name</label>
            <input type="text" name='vinNumber' [(ngModel)]='this.user.lastName' [class.is-invalid]='!this.user.lastName' class="form-control" id="inputPassword4">
          </div>
          <div class="form-group col-md-4">
            <label for="inputPassword4">New Password (Leave blank to keep current password)</label>
            <input type="password" name='vinNumber' [(ngModel)]='this.user.password' [class.is-invalid]='!this.user.password && this.user.id === -1' class="form-control" id="inputPassword4">
          </div>
        </div>
        <div class="form-row">
          <button type="submit" class="btn btn-success" (click)='saveProfile();$event.preventDefault();'>Save Profile</button>&nbsp;
          <button type="button" class="btn btn-danger" routerLink='/home'>Cancel</button>
        </div>
      </app-tab>
    </app-tabs>
  </div>
</div>
